import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// /admin is the Admin app's home-screen start URL: send signed-in admins to the portal (keeping ?tab=), everyone else to the admin login.
export default function AdminEntry() {
  const { search } = useLocation();
  const role = localStorage.getItem('user_role');
  const signedIn = !!localStorage.getItem('token') && ['admin', 'super_admin', 'editor'].includes(role);
  return <Navigate to={signedIn ? `/aqh-mgmt-7816${search}` : `/admin/login${search}`} replace />;
}
